// extracted by mini-css-extract-plugin
export var divider = "_ta-0";
export var systemMessage = "_ta-1";